var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26s.65-3.525 4.7-4.308c4.05-.784 4.3-1.763 4.3-2.546v-.98a6.918 6.918 0 01-2-3.426c-1.25 0-2-1.469-2-2.938 0-.391 0-1.958 1-1.958-.8-3.133-.2-6.365 2-6.365 5.2-3.427 12.5-.734 10 6.365 1 0 1 1.567 1 1.958 0 1.469-.75 2.938-2 2.938a6.87 6.87 0 01-2 3.427v.979c0 .783.25 1.762 4.3 2.546C26 22.622 26 26 26 26",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPerson;